<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.POPUP.SEARCH.USER') }}</i>
                    </dt>
                    <dd>
                        <div class="srchModal_wrap select_set2">
                            <dl class="dl_search">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p" v-model="searchKey">
                                        <option value="name">{{ $t('FIELD.USER.NAME') }}</option>
                                        <option value="id">{{ $t('FIELD.USER.ID') }}</option>
                                    </select>
                                </dd>
                                <dd data-input-type="input" class="clearable">
                                    <input type="text" class="text_input w100p" v-model="searchName" ref="searchNm" @keyup.enter.stop="onSearch()" v-clearable />
                                </dd>
                                <dd class="btn">
                                    <a href="javascript:" class="btn_srch" @click="onSearch()">
                                        {{ $t('FIELD.GLOBAL.SEARCH') }}
                                    </a>
                                </dd>
                            </dl>
                            <dl class="dl_search">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p" readonly>
                                        <option value="">{{$t('FIELD.FAQ.CORP')}}</option>
                                    </select>
                                </dd>
                                <dd data-input-type="input" class="clearable">
                                    <select class="slt_white w45p" v-model="rhqCd" @change="changeRhqCd()">
                                        <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                    </select>
                                    <select class="slt_white w50p" v-model="corpNo">
                                        <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                    </select>
                                </dd>
                            </dl>
                        </div>

                        <!-- Grid -->
                        <div class="grid_wrap mt-10">
                            <toast-grid
                                :gridId="gridId"
                                :columns="columns"
                                :data="gridData"
                                :options="options"
                                :ref="gridId"
                                :key="gridKey"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                                :click="contentClick"
                            />
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.SELECT') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue          from 'vue';
import axios        from 'axios';
import qs           from 'query-string';
import $            from 'jquery';
import api          from '@/service';
import store        from '@/vuex/store';
import { mapGetters } from 'vuex';
import SDLUtil      from '@/utils/SDLUtil';
import ToastGrid    from '~c/ToastGrid';

// Toast Grid Custom Renderer
class CustomButtonRenderer {
    //radio
    constructor(props) {
        // <label class="radiobox-wrap "><input type="radio"><i class="radio-icon"></i></label>
        const el = document.createElement('label');
        el.classList.add('radiobox-wrap');

        const subel = document.createElement('input');
        subel.setAttribute('type', 'radio');
        subel.setAttribute('name', 'radio');

        const subel1 = document.createElement('i');
        subel1.classList.add('radio-icon');

        el.appendChild(subel);
        el.appendChild(subel1);

        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

export default {
    name: 'searchUserPop',
    components: {
        'toast-grid': ToastGrid,
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            sLoginNo: 'getLoginNo'
        })
    },
    props: {
        disableLevel: '',
        disableDept: '',
        deptLevelCd: '',
        deptNo: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'searchUserPop',
            loginId: '',
            loginNo: '',
            loginNm: '',
            deptName: '',
            deptLevelNm: '',
            searchKey: 'name',
            searchName: '',
            rhqCdList: [],
            corpNoList: [],
            rhqCd: '',
            corpNo: '',
            searchGbmCd: '',
            searchRhqCd: '',
            searchSubsidiaryCd: '',
            gridKey: 0,
            gridId: 'searchUserPopGrid',
            columns: [
                {
                    header: '',
                    name: '',
                    align: 'center',
                    width: 40,
                    resizable: true,
                    sortable: false,
                    renderer: { type: CustomButtonRenderer },
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LOGIN.ID'),
                    name: 'LOGINID',
                    align: 'center',
                    width: 180,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.NAME'),
                    name: 'LOGINNAME',
                    align: 'center',
                    width: 220,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.ADMIN.PART.NAME'),
                    name: 'DEPTNAME',
                    align: 'center',
                    // width: 200,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 265,
            },
            pageOptions: {
                useClient: true,
                perPage: Number(localStorage.getItem('listRows')),
            },
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.sLoginNo);
            return codeResp;
        },
        // RhqCd 변경 시..
        changeRhqCd() {
//          this.loadSubsiCodes(this.rhqCd);
            this.getCodeComboList(this.rhqCd, 'SUB_AUTH_ACCESS_CD').then(data => {
                console.log('this.corpNoList ==> ', data);
                this.corpNoList = data;
                this.corpNo = '';
            });
        },
        async onSearch() {
            if (SDLUtil.textLength(this.searchName) < 2) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.SEARCH.USER'));
                return false;
            }

            let searchUserName = '';
            let searchUserId = '';
            if ('name' === this.searchKey) {
                searchUserName = this.searchName;
            } else {
                searchUserId = this.searchName;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/user/userSelectSearch.skp`,
                    qs.stringify({
                        searchUserName      : searchUserName,
                        searchUserId        : searchUserId,
                        searchDeptLevelCd   : this.deptLevelCd,
                        searchSubsidiaryCd  : this.searchSubsidiaryCd,
                        searchRhqCd         : this.rhqCd,
                        searchCorpNo        : this.corpNo,
                        searchGbmCd         : this.searchGbmCd,
                        userStatus          : 'A'
                    })
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            this.rtnFunc(this.loginNo, this.loginId, this.loginNm, this.deptName, this.deptLevelNm);
            this.$emit('close');
        },
        contentClick(e, rowData, grid) {
            let curRowKey = e.rowKey;
            if (curRowKey > this.pageOptions.perPage) {
                curRowKey = e.rowKey % this.pageOptions.perPage;
            }

            if ($('input[name=radio]')[curRowKey].checked) {
                this.loginNo     = rowData[e.rowKey]['LOGINNO'];
                this.loginId     = rowData[e.rowKey]['LOGINID'];
                this.loginNm     = rowData[e.rowKey]['LOGINNAME'];
                this.deptName    = rowData[e.rowKey]['DEPTNAME'];
                this.deptLevelNm = rowData[e.rowKey]['DEPTLEVELNM'];
            }
            // console.log('contentClick',e.rowKey,curRowKey,$('input[name=radio]')[curRowKey].checked,rowData[e.rowKey]['LOGINID'],rowData[e.rowKey]['LOGINNAME'],);
        },
    },
    mounted() {
        if ('4' === this.deptLevelCd) {
            this.searchGbmCd = this.deptNo;
        } else if ('3' === this.deptLevelCd) {
            this.searchRhqCd = this.deptNo;
        } else if ('2' === this.deptLevelCd) {
            this.searchSubsidiaryCd = this.deptNo;
        }
            console.log('this.sLoginNo ==> ', this.sLoginNo);
        this.getCodeComboList(this.sLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
            this.rhqCdList = data;
            console.log('data ==> ', data);
/*            this.getCodeComboList(this.rhqCdList[0].code, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
                console.log('data ==> ', data);
            });
*/
        });

        this.$refs.searchNm.focus();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/searchUserPop.vue